// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";
const name = "pointCloudVertex";
const shader = `#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
`;
// Sideeffect
if (!ShaderStore.IncludesShadersStore[name]) {
    ShaderStore.IncludesShadersStore[name] = shader;
}
/** @internal */
export const pointCloudVertex = { name, shader };
//# sourceMappingURL=pointCloudVertex.js.map